export default __webpack_public_path__ + "static/media/servicio-al-cliente.f3f93abb.png";